import THome from './index.vue';

THome.install = app => {
  app.component(THome.name, THome);
};

export default THome;
